










































import { Vue, Component, Prop } from 'vue-property-decorator';
import BaseLoaderCircular from '../base-loader-circular/_base-loader-circular.vue';
import Wave from '../../directives/wave';
import type { RainbowColor } from '../../styles/enums/RainbowColor';
import { RainbowColorHelper } from '../../styles/helpers/rainbow-color.helper';
import { ButtonType } from './types/enums/button-type';

@Component({
  name: 'BaseButton',
  components: {
    BaseLoaderCircular,
  },
  directives: {
    Wave,
  },
})
export default class BaseButton extends Vue {
  @Prop() id: string;
  @Prop({ default: ButtonType.Primary }) buttonType: ButtonType;
  @Prop({ required: false }) type?: 'button' | 'submit' | 'reset';
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) loaded: boolean;
  @Prop({ default: false }) loading: boolean;
  @Prop({ default: false }) active: boolean;
  @Prop({ default: false }) showLoaderText: boolean;
  @Prop({ default: false }) compact: boolean;
  @Prop() color?: RainbowColor;

  get disabledButton(): boolean {
    return this.disabled || this.loading || this.loaded;
  }

  get typeClass(): string {
    return `ga-${this.buttonType}`;
  }

  get hideText(): boolean {
    return this.loaded || this.loading;
  }

  get buttonId(): string {
    return this.id || `button-${this['_uid']}`;
  }

  get listeners(): Record<string, (arg?) => any> {
    return {
      ...this.$listeners,
      click: this.handleClick,
    };
  }

  get colorClass() {
    return this.color ? RainbowColorHelper.button(this.buttonType, this.color) : '';
  }

  handleClick(event: any) {
    if (this.disabledButton) return;

    this.$emit('click', event);
  }
}
